import PropTypes from 'prop-types';
import { UniversalLink } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';
import { Icon } from '@plone/volto/components';
import rightArrow from '@plone/volto/icons/backspace.svg';
import Moment from 'moment';

const getImageUrl = (item) => {
  if (
    item?.image_scales?.preview_image &&
    Array.isArray(item.image_scales.preview_image) &&
    item.image_scales.preview_image[0]?.scales?.preview?.download
  ) {
    return flattenToAppURL(
      `${item['@id']}/${item.image_scales.preview_image[0].scales.preview.download}`,
    );
  }
  if (item?.['@id']) {
    return flattenToAppURL(`${item['@id']}/@@images/image/preview`);
  }
  return null;
};

const NewsCard = ({ item }) => {
  const imageUrl = getImageUrl(item);
  return (
    <div className="card-container">
      {imageUrl && (
        <img className="item-image" src={imageUrl} alt={item?.title} />
      )}
      <div className="content">
        <p style={{ margin: '15px 0' }}>
          {Moment(item?.effective).format('DD/MM/YYYY')}
        </p>
        <h2>{item?.title}</h2>
        <p className="two-lines">{item?.description}</p>
        <p style={{ display: 'flex', alignItems: 'center', marginTop: '15px' }}>
          <UniversalLink href={item['@id']}>
            Leer más{' '}
            <Icon
              size="25px"
              style={{ transform: 'scale(-1, 1)' }}
              name={rightArrow}
            />
          </UniversalLink>
        </p>
      </div>
    </div>
  );
};

NewsCard.propTypes = {
  item: PropTypes.object.isRequired,
};

export default NewsCard;
